import { Directive, ElementRef, HostListener, Renderer2, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[ncRipple]'
})
export class RippleDirective implements OnInit {
  /** 波纹颜色 */
  @Input() ncColor: string = 'rgba(255, 255, 255, 0.5)';
  /** 动画时长，单位ms */
  @Input() ncDuration: number = 600;

  private rippleContainer!: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.createRippleContainer();
  }

  private createRippleContainer() {
    this.rippleContainer = this.renderer.createElement('div');
    this.renderer.addClass(this.rippleContainer, 'ripple-container');
    this.renderer.setStyle(this.rippleContainer, 'position', 'absolute');
    this.renderer.setStyle(this.rippleContainer, 'inset', '0');
    this.renderer.setStyle(this.rippleContainer, 'borderRadius', 'inherit');
    this.renderer.setStyle(this.rippleContainer, 'pointer-events', 'none');
    this.renderer.setStyle(this.rippleContainer, 'overflow', 'hidden');

    const elementPosition = getComputedStyle(this.el.nativeElement).position;
    if (!elementPosition || elementPosition === 'static') {
      this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    }

    this.renderer.appendChild(this.el.nativeElement, this.rippleContainer);
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const ripple = this.renderer.createElement('span');
    const diameter = Math.max(this.el.nativeElement.clientWidth, this.el.nativeElement.clientHeight);
    const radius = diameter / 2;

    this.renderer.setStyle(ripple, 'position', 'absolute');
    this.renderer.setStyle(ripple, 'border-radius', '50%');
    this.renderer.setStyle(ripple, 'pointer-events', 'none');
    this.renderer.setStyle(ripple, 'width', `${diameter}px`);
    this.renderer.setStyle(ripple, 'height', `${diameter}px`);
    this.renderer.setStyle(ripple, 'transform', 'scale(0)');
    this.renderer.setStyle(ripple, 'transition', `all ${this.ncDuration}ms`);
    this.renderer.setStyle(ripple, 'background-color', this.ncColor);
    this.renderer.setStyle(ripple, 'opacity', '1');

    const rect = this.el.nativeElement.getBoundingClientRect();
    const x = event.clientX - rect.left - radius;
    const y = event.clientY - rect.top - radius;

    this.renderer.setStyle(ripple, 'left', `${x}px`);
    this.renderer.setStyle(ripple, 'top', `${y}px`);

    this.renderer.appendChild(this.rippleContainer, ripple);

    setTimeout(() => {
      this.renderer.setStyle(ripple, 'transform', 'scale(2)');
      this.renderer.setStyle(ripple, 'opacity', '0');
      setTimeout(() => this.renderer.removeChild(this.rippleContainer, ripple), this.ncDuration);
    }, 0);
  }
}